import { useState } from "react";
import { SelectionContext, type ISelectedItem } from "./SelectionContext";

type SelectionContextProviderProps = {
  children: React.ReactNode;
};

export const SelectionContextProvider = ({
  children,
}: SelectionContextProviderProps) => {
  const [selectedItem, setSelectedItem] = useState<ISelectedItem | undefined>(
    undefined,
  );
  const [boundsShowingAllPatients, setBoundsShowingAllPatients] = useState<
    | readonly [{ lat: number; lng: number }, { lat: number; lng: number }]
    | undefined
  >(undefined);

  const clearSelection = () => {
    setSelectedItem(undefined);
  };

  return (
    <SelectionContext.Provider
      value={{
        selectedItem,
        setSelectedItem,
        clearSelection,
        boundsShowingAllPatients,
        setBoundsShowingAllPatients,
      }}
    >
      {children}
    </SelectionContext.Provider>
  );
};
